// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"89a8df8d","453":"b63d2120","695":"fc1c80d7"}[chunkId] + ".chunk.js";
};